import LineCharts from "./LineChart";
import React, { useState } from "react";

const HPI = ({ averages, modalChart, filteredHealth, setModalChart, dark }) => {
  const [HPIChart, setHPIChart] = useState(null);

  return (
    <div className="d-flex flex-row">
      <div className="d-flex flex-row">
        <span class="me-2 text-main badge">HPI :</span>
        <span
          data-bs-toggle="modal"
          data-bs-target="#HPI"
          onClick={() =>
            setHPIChart({
              name: "HPI",
              label: "Health Performance Indicator",
              color: "#FEC14B",
              lines: [{ color: "green", value: 500 }],
              unit: "",
              x: "enqueuedTime_Stamp",
              y: "HPI",
              data: filteredHealth.HPI,
            })
          }
          className={`cursor-pointer badge badge-secondary ${
            averages?.HPI > 4
              ? "bg-good"
              : averages?.HPI > 3
              ? "bg-moderate"
              : averages?.HPI > 2
              ? "bg-unhealthy-sensitive"
              : averages?.HPI > 1
              ? "bg-unhealthy"
              : averages?.HPI > 0
              ? "bg-very-unhealthy"
              : averages?.HPI == 0
              ? "bg-hazardous"
              : "bg-secondary"
          }`}
        >
          {averages?.HPI}
        </span>
      </div>
      <div
        className="modal fade "
        id="HPI"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabindex="-1"
        aria-labelledby="HPILabel"
        aria-hidden="true"
      >
        <div className="modal-dialog mw-100 w-100">
          <div className="modal-content dashboard-health">
            <div className="modal-header">
              <h5 className="modal-title" id="HPILabel">
                Health Performance Indicator
              </h5>
              <button
                type="button"
                className="btn-close btn-close-white"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body text-center">
              <div className="overflow-auto table-responsive">
                <table className="my-table text-main text-center table-bordered">
                  <thead>
                    <tr>
                      <th scope="col">Category</th>
                      <th scope="col">index</th>
                      <th scope="col" colSpan={2}>
                        Air Quality
                      </th>
                      <th scope="col" colSpan={2}>
                        PM2.5 (μg/m3)
                      </th>
                      <th scope="col" colSpan={2}>
                        PM10 (μg/m3)
                      </th>
                      <th scope="col" colSpan={2}>
                        CO (ppm)
                      </th>
                      <th scope="col" colSpan={2}>
                        CO2 (ppm)
                      </th>
                      <th scope="col" colSpan={2}>
                        O3 (ppm)
                      </th>
                      <th scope="col" colSpan={2}>
                        NO2 (ppm)
                      </th>
                      <th scope="col" colSpan={2}>
                        TVOC (ppb)
                      </th>
                      <th scope="col" colSpan={2}>
                        Humidex
                      </th>
                      <th scope="col" colSpan={2}>
                        Noise (dB)
                      </th>
                      <th scope="col" colSpan={2}>
                        Light (Lux)
                      </th>
                      <th scope="col" colSpan={2}>
                        Radon (Bq/m3)
                      </th>
                      <th scope="col">HPI</th>
                    </tr>
                  </thead>
                  <tbody NameName="">
                    <tr>
                      <th scope="col"></th>
                      <th scope="col"></th>
                      <th scope="col">min</th>
                      <th scope="col">max</th>
                      <th scope="col">min</th>
                      <th scope="col">max</th>
                      <th scope="col">min</th>
                      <th scope="col">max</th>
                      <th scope="col">min</th>
                      <th scope="col">max</th>
                      <th scope="col">min</th>
                      <th scope="col">max</th>
                      <th scope="col">min</th>
                      <th scope="col">max</th>
                      <th scope="col">min</th>
                      <th scope="col">max</th>
                      <th scope="col">min</th>
                      <th scope="col">max</th>
                      <th scope="col">min</th>
                      <th scope="col">max</th>
                      <th scope="col">min</th>
                      <th scope="col">max</th>
                      <th scope="col">min</th>
                      <th scope="col">max</th>
                      <th scope="col">min</th>
                      <th scope="col">max</th>
                      <th scope="col"></th>
                    </tr>
                    <tr className="text-black align-middle bg-good">
                      <td scope="col">Good</td>
                      <td scope="col">5</td>
                      <td scope="col">0</td>
                      <td scope="col">50</td>
                      <td scope="col">0</td>
                      <td scope="col">12</td>
                      <td scope="col">0</td>
                      <td scope="col">54</td>
                      <td scope="col">0</td>
                      <td scope="col">4.4</td>
                      <td scope="col">0</td>
                      <td scope="col">700</td>
                      <td scope="col">0</td>
                      <td scope="col">0.054</td>
                      <td scope="col">0</td>
                      <td scope="col">0.04</td>
                      <td scope="col">0</td>
                      <td scope="col">220</td>
                      <td scope="col">16</td>
                      <td scope="col">29</td>
                      <td scope="col">30</td>
                      <td scope="col">60</td>
                      <td scope="col">320</td>
                      <td scope="col">500</td>
                      <td scope="col">0</td>
                      <td scope="col">100</td>
                      <td scope="col">5</td>
                    </tr>
                    <tr className="text-black align-middle bg-moderate">
                      <td scope="col">Moderate</td>
                      <td scope="col">4</td>
                      <td scope="col">51</td>
                      <td scope="col">100</td>
                      <td scope="col">12.1</td>
                      <td scope="col">35.4</td>
                      <td scope="col">55</td>
                      <td scope="col">154</td>
                      <td scope="col">4.5</td>
                      <td scope="col">9.4</td>
                      <td scope="col">701</td>
                      <td scope="col">800</td>
                      <td scope="col">0.055</td>
                      <td scope="col">0.07</td>
                      <td scope="col">0.041</td>
                      <td scope="col">0.08</td>
                      <td scope="col">221</td>
                      <td scope="col">660</td>
                      <td scope="col">30</td>
                      <td scope="col">39</td>
                      <td scope="col">61</td>
                      <td scope="col">70</td>
                      <td scope="col">
                        200
                        <br />
                        500
                      </td>
                      <td scope="col">
                        319
                        <br />
                        700
                      </td>
                      <td scope="col">101</td>
                      <td scope="col">148</td>
                      <td scope="col">4</td>
                    </tr>
                    <tr className="text-black align-middle bg-unhealthy-sensitive">
                      <td scope="col">Unhealthy for sensitive groups​</td>
                      <td scope="col">3</td>
                      <td scope="col">101</td>
                      <td scope="col">150</td>
                      <td scope="col">35.5</td>
                      <td scope="col">55.4</td>
                      <td scope="col">155</td>
                      <td scope="col">254</td>
                      <td scope="col">9.5</td>
                      <td scope="col">12.4</td>
                      <td scope="col">801</td>
                      <td scope="col">1100</td>
                      <td scope="col">0.071</td>
                      <td scope="col">0.085</td>
                      <td scope="col">0.081</td>
                      <td scope="col">0.18</td>
                      <td scope="col">661</td>
                      <td scope="col">1430</td>
                      <td scope="col">40</td>
                      <td scope="col">45</td>
                      <td scope="col">71</td>
                      <td scope="col">80</td>
                      <td scope="col">
                        100
                        <br />
                        700
                      </td>
                      <td scope="col">
                        200
                        <br />
                        900
                      </td>
                      <td scope="col">148</td>
                      <td scope="col">185</td>
                      <td scope="col">3</td>
                    </tr>
                    <tr className="text-black align-middle bg-unhealthy">
                      <td scope="col">Unhealthy</td>
                      <td scope="col">2</td>
                      <td scope="col">151</td>
                      <td scope="col">200</td>
                      <td scope="col">55.55</td>
                      <td scope="col">150.4</td>
                      <td scope="col">255</td>
                      <td scope="col">345</td>
                      <td scope="col">12.5</td>
                      <td scope="col">15.4</td>
                      <td scope="col">1101</td>
                      <td scope="col">1500</td>
                      <td scope="col">0.086</td>
                      <td scope="col">0.105</td>
                      <td scope="col">0.181</td>
                      <td scope="col">0.28</td>
                      <td scope="col">1431</td>
                      <td scope="col">2200</td>
                      <td scope="col">46</td>
                      <td scope="col">54</td>
                      <td scope="col">81</td>
                      <td scope="col">90</td>
                      <td scope="col">
                        50
                        <br />
                        900
                      </td>
                      <td scope="col">
                        100
                        <br />
                        1500
                      </td>
                      <td scope="col">186</td>
                      <td scope="col">200</td>
                      <td scope="col">2</td>
                    </tr>
                    <tr className="text-black align-middle bg-very-unhealthy">
                      <td scope="col">Very Unhealthy</td>
                      <td scope="col">1</td>
                      <td scope="col">201</td>
                      <td scope="col">300</td>
                      <td scope="col">150.5</td>
                      <td scope="col">250.4</td>
                      <td scope="col">355</td>
                      <td scope="col">424</td>
                      <td scope="col">15.4</td>
                      <td scope="col">30.4</td>
                      <td scope="col">1501</td>
                      <td scope="col">2000</td>
                      <td scope="col">0.106</td>
                      <td scope="col">0.2</td>
                      <td scope="col">0.281</td>
                      <td scope="col">0.4</td>
                      <td scope="col">2201</td>
                      <td scope="col">3300</td>
                      <td scope="col">55</td>
                      <td scope="col">60</td>
                      <td scope="col">91</td>
                      <td scope="col">95</td>
                      <td scope="col">
                        25
                        <br />
                        1500
                      </td>
                      <td scope="col">
                        50
                        <br />
                        10000
                      </td>
                      <td scope="col">201</td>
                      <td scope="col">300</td>
                      <td scope="col">1</td>
                    </tr>
                    <tr className="text-black align-middle bg-hazardous ">
                      <td scope="col">Hazardous</td>
                      <td scope="col">0</td>
                      <td scope="col" className="bg-hazardous">
                        301
                      </td>
                      <td scope="col" className="bg-hazardous">
                        500
                      </td>
                      <td scope="col">250.2</td>
                      <td scope="col">500.4</td>
                      <td scope="col">425</td>
                      <td scope="col">604</td>
                      <td scope="col">30.5</td>
                      <td scope="col">50.4</td>
                      <td scope="col">2001</td>
                      <td scope="col">5000</td>
                      <td scope="col">0.2</td>
                      <td scope="col">1</td>
                      <td scope="col">0.4</td>
                      <td scope="col">1</td>
                      <td scope="col">3301</td>
                      <td scope="col">5500</td>
                      <td scope="col">61</td>
                      <td scope="col">65</td>
                      <td scope="col">96</td>
                      <td scope="col">140</td>
                      <td scope="col">
                        0<br />
                        10000
                      </td>
                      <td scope="col">
                        25
                        <br />
                        10000
                      </td>
                      <td scope="col">301</td>
                      <td scope="col">600</td>
                      <td scope="col">0</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="w-100" style={{ height: "400px" }}>
                {HPIChart && HPIChart.data.length > 0 && (
                  <LineCharts
                    dataList={HPIChart}
                    dark={dark}
                    aspect={3.5}
                    i={1}
                    key={1}
                    lines={HPIChart?.lines}
                    areas={HPIChart?.areas}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HPI;
